import React from 'react'

function Mapg() {
  return (
    <div>

      <div className="album py-0">

        <div className="container">

          <div className="row">
            <iframe className="iframe-fluid mb-2" width="520" height="230" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" src="https://maps.google.com/maps?width=520&amp;height=400&amp;hl=en&amp;q=Siddheshwari%20Bastralaya,%20Patuli%20Ghat%20Rd,%20opposite%20Siddheswari%20Bastralay,%20Bethuadahari,%20West%20Bengal%20741126%20+(Siddheshwari%20Bastralaya,%20Patuli%20Ghat%20Rd,%20opposite%20Siddheswari%20Bastralay,%20Bethuadahari,%20West%20Bengal%20741126)&amp;t=&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe>

            <iframe src="https://www.google.com/maps/embed?pb=!4v1739547436499!6m8!1m7!1scLL65zF3wGPQoJBd472CRQ!2m2!1d23.60816746263576!2d88.38135284746132!3f102.62636247695919!4f16.643202201896102!5f1.6015929241212814" width="600" height="350" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Mapg